import React, {ReactNode} from "react";
import "./form.scss";
import {Alert, AnchorButton, Button, Card, FormGroup, Icon, InputGroup, Intent, TextArea} from "@blueprintjs/core";
import useViewModel from "./Form.viewModel";

function FormPage(): ReactNode {
  const viewModel = useViewModel();

  if (viewModel.formClosed) {
    return (
      <div className="form_closed">
        <Icon intent={Intent.SUCCESS} icon="tick" size={60} />
        <p>Form submitted.</p>
        <p>Please check your email for a confirmation.</p>
        <AnchorButton href="https://www.portbannatynemarina.co.uk/">Back to main page</AnchorButton>
      </div>
    );
  }

  return (
    <Card className={"main"}>
      <form className="form_container" onSubmit={viewModel.onSubmit}>
        <FormGroup
          label="Owner Name"
          labelInfo="(required)"
        >
          <div className="control_group">
            <InputGroup className="form_item"
              onChange={(e) => viewModel.handleChange("firstName")(e.target.value)}
              placeholder={"First Name"}
              required
            />
            <InputGroup className="form_item"
              onChange={(e) => viewModel.handleChange("lastName")(e.target.value)}
              placeholder={"Last Name"}
              required
            />
          </div>
        </FormGroup>
        <FormGroup
          label="Owner Email"
          labelInfo="(required)"
        >
          <InputGroup
            onChange={(e) => viewModel.handleChange("email")(e.target.value)}
            placeholder="you@gmail.com"
            type="email"
            required
          />
        </FormGroup>
        <FormGroup
          label="Contact Number"
          labelInfo="(required)"
        >
          <InputGroup
            onChange={(e) => viewModel.handleChange("number")(e.target.value)}
            placeholder="07548 123456"
            required
          />
        </FormGroup>
        <FormGroup
          label="Boat Name"
          labelInfo="(required)"
        >
          <InputGroup onChange={(e) => viewModel.handleChange("boatName")(e.target.value)}
            placeholder={"Boat Name"}
            required
          />
        </FormGroup>
        <div className="form_details_container">
          <div className="details_title">
            <h3>Further Details</h3>
            <p>Please list the individual jobs required on the boat.</p>
          </div>
          {viewModel.data.details.map(({job, brief}, i) => (
            <div className="form_detail" key={i}>
              <FormGroup className="detail_item" label={"Job " + (i + 1)}>
                <InputGroup onChange={(e) => viewModel.handleDetailTitleChange(i, e.target.value)} value={job}/>
              </FormGroup>
              <FormGroup className="detail_item" label="Brief">
                <TextArea className="form_text_area"
                  onChange={(e) => viewModel.handleDetailDescChange(i, e.target.value)}
                  value={brief}
                  fill
                />
              </FormGroup>
              <Button onClick={() => viewModel.deleteDetail(i)} minimal icon="cross" />
            </div>
          ))}
          <Button onClick={() => viewModel.addDetail()} text="Add another detail" />
        </div>
        <FormGroup
          label="Any other notes, or things we should know..."
        >
          <TextArea
            className="form_text_area"
            onChange={(e) => viewModel.handleChange("extraDetails")(e.target.value)}
            fill
          />
        </FormGroup>

        <Button type={"submit"} loading={viewModel.isBusy} intent="primary" text={"Submit"}/>
      </form>
      <Alert
        intent={Intent.DANGER}
        isOpen={viewModel.formFailureMessage != null}
        onClose={viewModel.onFailureDismiss}
      >
        <p>{viewModel.formFailureMessage}</p>
      </Alert>
      <Alert
        intent={Intent.SUCCESS}
        isOpen={viewModel.formSuccessMessage != null}
        onClose={viewModel.onSuccessDismiss}
      >
        <p>{viewModel.formSuccessMessage}</p>
      </Alert>
    </Card>
  );
}

export default FormPage;
